module.exports = __webpack_public_path__ + "img/ico_no_data.b9c28232.svg";